import { breakpoints, useHooks } from '@everlywell/leaves';
import {
  GatsbyImage as Img,
  IGatsbyImageData,
  withArtDirection,
} from 'gatsby-plugin-image';

import React from 'react';

export type BackgroundImageProps = {
  fluidImage: IGatsbyImageData;
  mobileFluidImage?: IGatsbyImageData;
  verticalCenter?: boolean;
  alt?: string;
};

/**
 * Background Image component for the hero section - uses gatsby-plugin-image and withArtDirection
 * to efficiently render the hero image
 * https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/#withartdirection
 */

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  fluidImage,
  mobileFluidImage,
  verticalCenter,
  alt,
}) => {
  const sources = withArtDirection(fluidImage, [
    {
      media: `(max-width: ${breakpoints.forTabletVerticalUp}px)`,
      image: mobileFluidImage as IGatsbyImageData,
    },
  ]);

  const { isDesktop } = useHooks.useWindowSize();

  return (
    <Img
      image={sources}
      loading="eager"
      className="heroBackgroundImage"
      alt={alt || 'hero background image'}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
      objectFit="cover"
      objectPosition={
        isDesktop && verticalCenter ? 'center 20%' : 'center center'
      }
    />
  );
};

export default BackgroundImage;
